import { render, staticRenderFns } from "./Reporte-bancos-corepay.vue?vue&type=template&id=368a012a&scoped=true&"
import script from "./Reporte-bancos-corepay.vue?vue&type=script&lang=js&"
export * from "./Reporte-bancos-corepay.vue?vue&type=script&lang=js&"
import style0 from "./Reporte-bancos-corepay.vue?vue&type=style&index=0&id=368a012a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a012a",
  null
  
)

export default component.exports